import Authenticate from '@/components/Authenticate';

function AuthenticatePage() {
  return (
    <>
      <Authenticate />
    </>
  );
}
export default AuthenticatePage;
